import React from 'react';
import { useLocation } from 'react-router-dom';
import { parseWikiUrl } from '../../../utils/wikiUrlParser';
import { getNavigationLevel } from '../../../utils/wikiNavigationUtils';
import { useWikiTypes } from '../../../contexts/WikiTypesContext';
import WikiMainPage from '../WikiMainPage';
import WikiCategoryPage from '../WikiCategoryPage';
import WikiItemDetailPage from '../WikiItemDetailPage';
import WikiVisualNavigationPage from '../WikiVisualNavigationPage';

/**
 * RESTful Router for Wiki pages
 * Handles dynamic parsing of RESTful URLs like:
 * - /wiki/armors -> WikiVisualNavigationPage (карточки подкатегорий)
 * - /wiki/armors/subcategories/5 -> WikiVisualNavigationPage (карточки типов)
 * - /wiki/armors/subcategories/5/types/41 -> WikiVisualNavigationPage или WikiCategoryPage
 * - /wiki/armors/subcategories/5/types/41/subtypes/2 -> WikiCategoryPage (список предметов)
 * - /wiki/armors/details/123 -> WikiItemDetailPage
 * - /wiki/skills/races/1 -> WikiVisualNavigationPage (карточки типов скиллов)
 * - /wiki/skills/races/1/types/2/classes/3/professions/4 -> WikiCategoryPage (список скиллов)
 */
const WikiRestfulRouter: React.FC = () => {
  const location = useLocation();
  const { categories } = useWikiTypes();

  // Parse the current URL
  const urlParams = parseWikiUrl(location.pathname);

  if (!urlParams) {
    // Invalid URL, redirect to main
    return <WikiMainPage />;
  }

  // Route to appropriate component based on URL structure
  if (urlParams.isDetailPage && urlParams.itemId) {
    // Detail page: show specific item
    return <WikiItemDetailPage />;
  }

  // Определяем уровень навигации - показывать карточки или список предметов
  const { showCards } = getNavigationLevel(urlParams, categories);

  if (showCards) {
    // Промежуточный уровень - показываем визуальные карточки
    return <WikiVisualNavigationPage />;
  } else {
    // Листовой уровень - показываем список предметов
    return <WikiCategoryPage />;
  }
};

export default WikiRestfulRouter;